import { PopoverBaseProps, PopoverContentProps } from '@procore/core-react/dist/_typedoc/Popover/Popover.types.json';
import * as React from 'react';
export default {
  PopoverBaseProps,
  PopoverContentProps,
  React
};